import COMMON_LABELS from "../../../../common/locale/th_TH";

export const LABELS: Record<string, string> = {
    ...COMMON_LABELS,
};

export default LABELS;
